"use strict";
/**
 * Creates a deprecation warning for a specified component with the provided message if the environment is not production.
 * @param componentName
 * @param message
 * @returns nothing
 */
Object.defineProperty(exports, "__esModule", { value: true });
const deprecate = (componentName, message, appName = 'TDS') => {
    if (process.env.NODE_ENV === 'production') {
        return;
    }
    console.warn(`[${appName}] [Deprecate] ${componentName}: ${message}`); // eslint-disable-line no-console
};
exports.default = deprecate;
//# sourceMappingURL=deprecate.js.map